import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/styles.css';

import Views from './views';

ReactDOM.render(
  <React.StrictMode>
    <Views />
  </React.StrictMode>,
  document.getElementById('root')
);
